import type { ReactNode } from "react";

interface SectionTitleProps {
  index: string;
  kicker: string;
  title: ReactNode;
  lead?: string;
  align?: "left" | "center";
}

export default function SectionTitle({
  index,
  kicker,
  title,
  lead,
  align = "left",
}: SectionTitleProps) {
  return (
    <div className={`mb-10 md:mb-14 ${align === "center" ? "text-center mx-auto max-w-2xl" : ""}`}>
      <div
        className={`flex items-center gap-3 ${align === "center" ? "justify-center" : ""}`}
      >
        <span className="inline-flex h-6 w-6 items-center justify-center rounded-full bg-primary-500 text-background-50 text-[11px] font-medium tracking-wide">
          {index}
        </span>
        <span className="text-xs md:text-[13px] font-medium tracking-[0.3em] text-accent-600 uppercase">
          {kicker}
        </span>
        <span className={`hidden h-px w-10 md:block bg-foreground-300/70 ${align === "center" ? "hidden" : ""}`} />
      </div>
      <h2 className="mt-4 font-serif text-2xl md:text-[34px] leading-tight font-bold text-foreground-950 md:leading-[1.15]">
        {title}
      </h2>
      {lead && (
        <p className="mt-4 max-w-2xl text-sm md:text-[15px] leading-7 text-foreground-500">
          {lead}
        </p>
      )}
    </div>
  );
}